import axios from 'axios';
import StorageManager from 'src/managers/StorageManager';
import * as types from 'src/store/mutation-types';

const state = {
  data: {
    display_image: {
      sizes: {
        default: {},
        large: {},
        medium: {},
        small: {},
      },
    },
    email: null,
    id: null,
    lang: 'th',
    name: null,
    role: null,
    team: {},
    team_id: null,
  },
  error: null,
  isLoading: false,
};

const getters = {
  currentUser: state => state.data,

  getCurrentUserError: state => state.error,

  isLoadingCurrentUser: state => state.isLoading,
};

const actions = {
  getCurrentUser ({ commit }) {
    commit(types.FETCH_CURRENT_USER_REQUEST);

    axios.get(`/api/user`)
    .then((response) => {
      commit(types.FETCH_CURRENT_USER_SUCCESS, response.data);

      commit(types.SAVE_CURRENT_TEAM, response.data.team);
    })
    .catch((error) => {
      commit(types.FETCH_CURRENT_USER_FAILURE, error);
    });
  },

  updateCurrentUserTeam ({ commit }, team) {
    commit(types.UPDATE_CURRENT_USER_TEAM, team);

    commit(types.SAVE_CURRENT_TEAM, team);
  },

  updateCurrentUserLang({ commit }, lang) {
    commit(types.UPDATE_CURRENT_USER_LANG, lang);
  },

  clearCurrentUser({ commit }) {
    commit(types.CLEAR_CURRENT_USER);
  },
};

const mutations = {
  [types.FETCH_CURRENT_USER_REQUEST] (state) {
    state.isLoading = true;
  },

  [types.FETCH_CURRENT_USER_SUCCESS] (state, user) {
    state.isLoading = false;
    state.data = user;
  },

  [types.FETCH_CURRENT_USER_FAILURE] (state, error) {
    state.isLoading = false;
    state.error = error;
  },

  [types.UPDATE_CURRENT_USER_TEAM] (state, team) {
    state.data.team = team;
  },

  [types.SAVE_CURRENT_TEAM] (state, team) {
    const storageManager = new StorageManager();
    storageManager.setTeam(team);
  },

  [types.UPDATE_CURRENT_USER_LANG] (state, lang) {
    state.data.lang = lang;
  },

  [types.CLEAR_CURRENT_USER] (state) {
    state.data = null;
    state.error = null;
    state.isLoading = false;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/current-user.js